import { useTranslate } from '@im/react-localization';
import { GridColDef } from '@mui/x-data-grid';
import React from 'react';
import DetailsDialog from './BidDetailsDialog';
import { useDateTimeFormatter } from 'src/hooks/dateTimeFormatter';
import { BidRowList } from '../../hooks/useBLCHooks';

export function useGetColumns() {
  const translate = useTranslate();
  const formatDateTime = useDateTimeFormatter();
  const columnsData: {
    field: string;
    headerName: string;
    type?: string;
  }[] = [
    {
      field: 'bidNumber',
      headerName: translate('BidLifeCycle.ColumnBidNumber'),
      type: 'bidNumber',
    },
    {
      field: 'vendorName',
      headerName: translate('BidLifeCycle.ColumnVendor'),
    },
    {
      field: 'vendorProgramName',
      headerName: translate('BidLifeCycle.ColumnVendorProgram'),
    },
    {
      field: 'currentStatus',
      headerName: translate('BidLifeCycle.ColumnCurrentStatus'),
    },
    {
      field: 'bcn',
      headerName: translate('BidLifeCycle.ColumnBCN'),
    },
    {
      field: 'resellerName',
      headerName: translate('BidLifeCycle.ColumnResellerName'),
    },
    {
      field: 'quoteNumber',
      headerName: translate('BidLifeCycle.ColumnQuoteNumber'),
    },
    {
      field: 'quoteStatus',
      headerName: translate('BidLifeCycle.ColumnQuoteStatus'),
    },
    {
      field: 'statusDateTimeUTC',
      headerName: translate('BidLifeCycle.ColumnBidReceived'),
      type: 'dateTime',
    },
  ];
  const columns: GridColDef<BidRowList>[] = columnsData.map((column) => {
    return {
      field: column.field,
      flex: 2,
      headerName: column.headerName,
      renderCell: (item) => {
        switch (column.type) {
          case 'bidNumber':
            return <DetailsDialog item={item} />;
          case 'dateTime':
            return formatDateTime(item.value, true);
          default:
            return item.value;
        }
      },
      sortable: false,
    };
  });
  return columns;
}
